/* eslint-disable indent */
import { useEffect, useState } from 'react';
import '../style.scss';
import ReactPaging from '../../../components/Table/ReactPaging';
import { TAB_ID } from '../ShareKnowledgeScreen';
import { useStore } from '../../../core/utils/hook';
import ModalUploadVideo from './ModalUploadVideo';
import ModalEditVideo from './ModalEditVideo';
import ModalUploadDocument from './ModalUploadDocument';
import {
    downloadFileBySignedUrl,
    extractFileNameAndExt,
    formatBytes
} from '../../../core/utils/common';
import { handleDownloadFile } from '../../../core/utils/file';
import { useForm } from 'react-hook-form';

import {
    IconDelete,
    IconDownload,
    IconEdit,
    IconSort,
    IconUploadDocument,
    IconUploadVideo,
    IconView
} from './Icon';
import { ReactNotifications, VideoPlayer } from '../../../components';
import {
    DATE_TIME_YMD,
    EXTENSION_FILE_MAPPER,
    MSG,
    SHARE_KNOWLEDGE_FILE_TYPE,
    SYSTEM_PATH
} from '../../../core/configs/constants';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

function renderFileIcon(fileType, url) {
    const iconKeyDoc = Object.keys(EXTENSION_FILE_MAPPER).filter(key => EXTENSION_FILE_MAPPER[key].VALUE.includes(fileType.toLowerCase()));
    const iconPath = iconKeyDoc?.length > 0 ? (
        iconKeyDoc[0] === 'IMAGE' ? url : EXTENSION_FILE_MAPPER[iconKeyDoc[0]].ICON
    ) : '/images/img-1-1.png';

    return (
        <>
            {
                iconKeyDoc?.length > 0 && iconKeyDoc[0] !== 'IMAGE' ? (
                    <div className='d-flex align-items-center justify-content-center flex-none'
                        style={{ padding: '8px 10px', width: '45px', height: '45px',
                            border: '1px solid #FFB900', borderRadius: '5px' }}>
                            <img src={iconPath}
                                alt=''
                                style={{ width: 'auto', height: '30px' }} />
                        </div>
                ) : (
                    <img
                        src={iconPath}
                        alt={fileType}
                        className='flex-none'
                        style={{ width: '45px', height: '45px' }}
                    />
                )
            }
        </>
        
    );
}

const UploadedList = ({ type }) => {
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, getValues } = useForm({
        defaultValues: {
            name: '',
            sortBy: 'newest'
        }
    });
    const [lstFile, setLstFile] = useState([]);
    // store
    const {
        modalStore: { hide, show, openWarningModal },
        shareKnowledgeStore: {
            getFilesGroup,
            deleteFile,
            getGroupInfo,
            getPresignedUrlsDonwload,
            getFileInfo,
            groupInfo
        }
    } = useStore();

    const [page, setPage] = useState(1);

    const [searchText, setSearchText] = useState(null);

    useEffect(() => {
        if (searchText === null) return;
        const timeout = setTimeout(() => {
            handleSubmit(onSubmit)();
        }, 500);

        return () => clearTimeout(timeout);
    }, [searchText]);

    useEffect(() => {
        if (
            Object.keys(lstFile).length > 0 &&
            lstFile?.elements?.length === 0 &&
            lstFile?.paginate?.totalPage > 0 &&
            lstFile?.paginate?.totalPage < page
        ) {
            setPage(lstFile?.paginate?.totalPage);
        }
    }, [lstFile]);

    const fetchFilesGroup = async (params) => {
        const res = await getFilesGroup(params);
        if (res) {
            setLstFile(res);
        }
    };

    const onSubmit = (values) => {
        fetchFilesGroup({ page: 1, type, ...values });
    };

    useEffect(() => {
        const values = getValues();
        fetchFilesGroup({ page, type, ...values });
    }, [page, type]);

    const openModalUploadVideo = () => {
        show({
            id: '',
            isOpen: true,
            header: '動画をアップロード',
            onCancel: () => hide(),
            children: (
                <ModalUploadVideo
                    onUploadSuccess={() => {
                        getGroupInfo(), refecthgetFileGroup();
                    }}
                />
            ),
            type: 'medium'
        });
    };

    const openModalEditVideo = async (id) => {
        show({
            id: '',
            isOpen: true,
            header: '動画編集',
            onCancel: () => hide(),
            children: (
                <ModalEditVideo
                    id={id}
                    onUploadSuccess={() => {
                        getGroupInfo(), refecthgetFileGroup();
                    }}
                />
            ),
            type: 'medium'
        });
    };

    const openModalUploadDoc = () => {
        show({
            id: '',
            isOpen: true,
            header: 'ファイルをアップロード',
            onCancel: () => hide(),
            children: (
                <ModalUploadDocument
                    onUploadSuccess={() => {
                        getGroupInfo(), refecthgetFileGroup();
                    }}
                />
            ),
            type: 'medium'
        });
    };

    const openModalDelete = (id) => {
        openWarningModal(
            'このファイルを削除してもよろしいですか。',
            () => onDeleteFile(id),
            '確認',
            'small',
            '承認',
            'キャンセル'
        )
    };

    const onDeleteFile = async (id) => {
        const res = await deleteFile({ ids: [id] });
        if (res) {
            hide();
            ReactNotifications('success', MSG['inform.success.delete'])
            getGroupInfo();
            refecthgetFileGroup();
        }
    };

    const onDownload = async ({ fileId: id, url, name }) => {
        const { extension } = extractFileNameAndExt(name);
        if (extension === 'pdf') {
            window.open(url, '_self');
            return;
        }
        const res = await getPresignedUrlsDonwload({
            id
        });
        if (res) {
            downloadFileBySignedUrl(res.url);
        }
    };

    const onExportViewersCsv = ({ fileId }) => {
        handleDownloadFile({
            url: `share-knowledge/group/file/${fileId}/viewers/export`,
            method: 'get',
            data: {},
            cb: () => {}
        });
    };

    const refecthgetFileGroup = () => {
        const values = getValues();
        fetchFilesGroup({ page, type, ...values });
    };

    const renderFileList = (elements, type) => {
        return (
            <div className="uploaded-list">
                {elements?.length > 0 ? (
                    elements?.map((el, index) => {
                        const { name, extension } = extractFileNameAndExt(
                            el.name || ''
                        );

                        return (
                            <div className="file-card flex" key={index}>
                                {type === TAB_ID.DOCUMENT ? (
                                    <div className="file-card-info">
                                        <div className="image-group flex justify-center item-center">
                                            {renderFileIcon(extension, el.url)}
                                        </div>
                                        <div className="name-group">
                                            <p className="text-black font-bold flex item-center">
                                                <p
                                                    className="file-name line-clamp-1"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="bottom"
                                                    title={name}
                                                >
                                                    {name}
                                                </p>
                                                <span className="file-ext">
                                                    .{extension}
                                                </span>
                                            </p>
                                            <p className="text-13 info">
                                                <span>
                                                    {formatBytes(+el.size)}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="file-card-info">
                                        <div
                                            className="image-group cursor-pointer flex-none"
                                            onClick={async () => {
                                                if (
                                                    !el.videoConversionStatus ||
                                                    !(await getFileInfo(
                                                        el.fileId
                                                    ))
                                                )
                                                    return;
                                                onShowModalVideo(
                                                    el.url,
                                                    el.name,
                                                    el.fileId,
                                                    el.thumbnailDefault
                                                );
                                            }}
                                        >
                                            <img
                                                src={
                                                    el.thumbnailUrl
                                                        ? el.thumbnailUrl
                                                        : '/images/img-1-1.png'
                                                }
                                            />
                                        </div>
                                        <div
                                            className="name-group cursor-pointer"
                                            onClick={async () => {
                                                if (
                                                    !el.videoConversionStatus ||
                                                    !(await getFileInfo(
                                                        el.fileId
                                                    ))
                                                )
                                                    return;

                                                onShowModalVideo(
                                                    el.url,
                                                    el.name,
                                                    el.fileId,
                                                    el.thumbnailDefault
                                                );
                                            }}
                                        >
                                            <p className="text-black font-bold flex item-center">
                                                {/* <p style={{width: '120px'}}>( ビデオ変換中 )</p> */}

                                                <p
                                                    className="file-name line-clamp-1"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="bottom"
                                                    title={name}
                                                >
                                                    {name}
                                                </p>
                                                <span className="file-ext">
                                                    .{extension}
                                                </span>
                                            </p>
                                            <p className="text-13 info">
                                                <span>
                                                    {formatBytes(+el.size)}
                                                </span>
                                                {!el.videoConversionStatus ? (
                                                    <span>
                                                        <img
                                                            src="/images/loading-7528_512.gif"
                                                            style={{
                                                                height: '15px',
                                                                transform:
                                                                    'translateY(-2px)',
                                                                marginRight:
                                                                    '2px'
                                                            }}
                                                        />
                                                        <span style={{ color: '#FCB900' }}>ビデオ変換中</span>
                                                    </span>
                                                ) : (
                                                    <>
                                                        <span>|</span>
                                                        <a
                                                            className="text-gray-primary flex item-center cursor-pointer"
                                                            style={{ color: '#139DE2', textDecoration: 'none' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate(SYSTEM_PATH.SHARE_KNOWLEDGE_VIEWER_LIST.replace(':fileId', el.fileId));
                                                            }}
                                                        >
                                                            {el.totalView}
                                                            <span style={{ transform: 'translateY(-3px)' }}>
                                                                {IconView()}
                                                            </span>
                                                            視聴済み
                                                        </a>
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                <div className="upload-date">
                                    <p className="text-gray-primary text-13">
                                        アップロード日
                                    </p>
                                    <p className="text-14 text-black font-bold">
                                        {el.createdAt
                                            ? moment(el.createdAt).format(
                                                  DATE_TIME_YMD
                                              )
                                            : ''}
                                    </p>
                                </div>
                                <div className="uploader">
                                    <p className="text-gray-primary text-13">
                                        アップロード者
                                    </p>
                                    <p
                                        className="text-14 text-black font-bold truncate"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="bottom"
                                        title={el.uploader}
                                    >
                                        {el.uploader}
                                    </p>
                                </div>
                                <div className="action">
                                    {el.type === SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => onDownload(el)}
                                        >
                                            {IconDownload()}
                                        </div>
                                    )}
                                    {el.type !== SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => onExportViewersCsv(el)}
                                        >
                                            {IconDownload()}
                                        </div>
                                    )}

                                    {type === TAB_ID.VIDEO && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                openModalEditVideo(el.fileId)
                                            }
                                        >
                                            {IconEdit()}
                                        </div>
                                    )}
                                    <div
                                        className="cursor-pointer"
                                        onClick={() =>
                                            openModalDelete(el.fileId)
                                        }
                                    >
                                        {IconDelete()}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                        データはありません
                    </div>
                )}
            </div>
        );
    };

    const renderSearchBox = () => {
        return (
            <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex justify-between wrap header"
            >
                <div className="flex item-center gap-10 header-container">
                    <div className="search-container">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="ファイル名で検索"
                            {...register('name')}
                            onChange={(e) => {
                                setSearchText(e.target.value);
                                setValue('name', e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleSubmit(onSubmit)();
                                }
                            }}
                        />
                        <span
                            className="search-icon"
                            onClick={() => handleSubmit(onSubmit)()}
                        >
                            <img
                                src="/images/icon-search.svg"
                                style={{ width: '17px' }}
                            />
                        </span>
                    </div>
                    <div
                        className="sort-container"
                        style={{
                            border: '1px solid #E5E5E5',
                            padding: '0 10px',
                            borderRadius: '5px'
                        }}
                    >
                        {IconSort()}
                        <select
                            className="select-type"
                            {...register('sortBy')}
                            onChange={(e) => {
                                setValue('sortBy', e.target.value);
                                handleSubmit(onSubmit)();
                            }}
                        >
                            <option value="newest">新しい順</option>
                            <option value="oldest">古い順</option>
                            {type === TAB_ID.VIDEO && (
                                <option value="view"> 閲覧数順</option>
                            )}
                        </select>
                    </div>
                </div>
                {type === TAB_ID.VIDEO ? (
                    +groupInfo.totalVideoSize <
                    +groupInfo.videoMaximumCapacity ? (
                        <button
                            className="btn-upload"
                            type="button"
                            onClick={openModalUploadVideo}
                        >
                            {IconUploadVideo()}動画をアップロード
                        </button>
                    ) : null
                ) : +groupInfo.totalDocumentSize <
                  +groupInfo.documentMaximumCapacity ? (
                    <button
                        className="btn-upload"
                        type="button"
                        onClick={openModalUploadDoc}
                    >
                        {IconUploadDocument()}ファイルをアップロード
                    </button>
                ) : null}
            </form>
        );
    };

    const ModalVideoContent = ({ video, thumbnail }) => {
        if (!video) {
            return (
                <div className="not-show-video">
                    <img
                        src={'/images/img-1.png'}
                        alt=""
                        style={{ height: '100%', objectFit: 'fill' }}
                    />
                    <p>後にご覧いただけます。</p>
                </div>
            );
        }

        return (
            <VideoPlayer
                options={{
                    poster: thumbnail,
                    sources: [
                        {
                            src: video,
                            type: video.toLowerCase().includes('m3u8')
                                ? 'application/x-mpegURL'
                                : 'video/mp4'
                        }
                    ]
                }}
                width={570}
                height={250}
                disableForward={false}
            />
        );
    };

    const onShowModalVideo = (video, fileName, id, thumbnail) => {
        show({
            id: 'modal-play-video-share-knowledge',
            header: <div className="line-clamp-1">{fileName}</div>,
            isOpen: true,
            onCancel: () => hide(),
            children: (
                <div style={{ padding: '15px' }}>
                    <ModalVideoContent video={video} thumbnail={thumbnail} />
                </div>
            ),
            type: 'medium max-width-600'
        });
    };
    return (
        <div className="uploaded-container">
            {type === TAB_ID.VIDEO ? (
                <>
                    {renderSearchBox()}
                    {renderFileList(lstFile?.elements, type)}
                </>
            ) : (
                <>
                    {renderSearchBox()}
                    {renderFileList(lstFile?.elements, type)}
                </>
            )}
            {lstFile?.elements?.length > 0 && (
                <div className="paging-container">
                    <ReactPaging
                        forcePage={lstFile?.paginate?.page - 1 || 0}
                        pageCount={lstFile?.paginate?.totalPage || 0}
                        onPageChange={({ selected }) => {
                            setPage(selected + 1);
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default UploadedList;
